import React from 'react';
import { cn } from '../../lib/utils';

const Textarea = React.forwardRef(({ label, error, className, id, ...props }, ref) => {
  const inputId = id || props.name;

  return (
    <label className='block space-y-2' htmlFor={inputId}>
      {label ? <span className='text-sm font-medium text-ink-800'>{label}</span> : null}
      <textarea
        id={inputId}
        ref={ref}
        className={cn(
          'w-full rounded-lg border bg-white px-4 py-3 text-ink-900 placeholder:text-ink-400 shadow-soft transition duration-200 ease-luxury focus:outline-none',
          error
            ? 'border-danger-500 focus:ring-2 focus:ring-danger-500/20'
            : 'border-pearl-400 focus:border-gold-500 focus:ring-2 focus:ring-gold-500/20',
          className
        )}
        {...props}
      />
      {error ? <p className='text-sm text-danger-500'>{error}</p> : null}
    </label>
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };
